import {
    TroubleEventStatus,
    TroubleEventType, TroubleEvent,
    getTroubleEventTypeText,
    getTroubleEventStatusClass,
    getTroubleEventStatusText,
    ITroubleEvent
} from './TroubleEvent'
import * as _ from 'lodash'
import DateTimeHelper from '../Helpers/DateTimeHelper'
import Payment from './Payment'
import LocalizationStore from '../Stores/LocalizationStore'
import PhoneHelper from '../Helpers/PhoneHelper'
import ProductHelper from '../Helpers/ProductHelper'
import ReactTable, { CellInfo } from 'react-table'
import { Link } from 'react-router-dom'
import * as React from 'react'
import EventsStore from '../Stores/EventsStore'
import HttpActionsService from '../Services/HttpActionsService'
import * as c from 'classnames'
import CommentHelper from '../Helpers/CommentHelper'
import ConfigStore from '../Stores/ConfigStore'
import { toJS } from 'mobx'
import {
    getPaymentSchedule,
    getCreditBodySum,
    getPaymentPerMonth,
    getCurrentDebtByCreditBody,
    getLastPenaltyAmountFromList,
    getCurrentDebt,
    getPaymentsSum,
    getFeeSum
} from '../Helpers/PaymentScheduleHelper'
import UserStore from '../Stores/UserStore'
import EnumHelpers from '../Helpers/EnumHelpers'

export class TroubleEventsTableItem {
    constructor(
        troubleEvent: TroubleEvent,
    ) {
        let scheduleArr = getPaymentSchedule(troubleEvent.credit.creditCondition.paymentsScheduleJson)
        let penalty = getLastPenaltyAmountFromList(troubleEvent.credit.penalties)

        this.id = troubleEvent.id
        this.createDate = troubleEvent.createDate
        this.types = troubleEvent.type
        this.statuses = troubleEvent.status
        this.assignedUserId = troubleEvent.assignedUserId
        this.name =
            `${troubleEvent.questionnaire.client.surname}` +
            (troubleEvent.questionnaire.client.name ? ` ${troubleEvent.questionnaire.client.name}` : '') +
            (troubleEvent.questionnaire.client.middleName ? ` ${troubleEvent.questionnaire.client.middleName}` : '')
        this.creditNumber = troubleEvent.credit.creditNumber
        this.phones = PhoneHelper.convertToString(troubleEvent.questionnaire.client.phones)
        this.products = ProductHelper.convertToString(troubleEvent.credit.products)
        this.openCreditDate = DateTimeHelper.formatDateForList(troubleEvent.credit.createDate)
        this.lastPaymentDate = GetLastPaymentDate(troubleEvent.credit.payments)
        this.creditDuration = troubleEvent.credit.creditCondition.termCountMonths
        this.creditBodySum = getCreditBodySum(
            scheduleArr,
            troubleEvent.credit.creditCondition.prepaymentSum)
        this.paymentPerMonth = getPaymentPerMonth(scheduleArr)
        this.prepaymentSum = troubleEvent.credit.creditCondition.prepaymentSum
        this.penalty = penalty
        this.lastComment = CommentHelper.getLastComment(troubleEvent.questionnaire.comments)
        this.expireDate = DateTimeHelper.formatDateForList(troubleEvent.endDate)
        this.currentDebtByCreditBody = getCurrentDebtByCreditBody(
            troubleEvent.credit.creditDetail.balance,
            scheduleArr,
            troubleEvent.credit.creditCondition.prepaymentSum)
        this.currentDebt = getCurrentDebt(
            troubleEvent.credit.creditDetail.balance,
            scheduleArr,
            troubleEvent.credit.creditCondition.prepaymentSum,
            penalty)
        this.totalCustomerPayments = getPaymentsSum(troubleEvent.credit.payments) - getFeeSum(troubleEvent.credit.payments)
        this.paidFee = getFeeSum(troubleEvent.credit.payments)
    }
    id: string
    name: string
    creditNumber: string
    phones: string
    products: string
    createDate: string
    types: TroubleEventType
    statuses: TroubleEventStatus
    assignedUserId: string
    creditDuration: number
    creditBodySum: number
    paymentPerMonth: number
    prepaymentSum: number
    penalty: number
    lastComment: string
    openCreditDate: string
    lastPaymentDate: string
    expireDate: string
    currentDebtByCreditBody: number
    currentDebt: number
    totalCustomerPayments: number
    paidFee: number
}

export function GetLastPaymentDate(payments: Array<Payment> | null) {
    let result = ''
    try {
        if (payments) {
            result = DateTimeHelper.formatDateForList(_.orderBy(payments, x => x.createDate, 'desc')[0].paymentDateTime)
        }
    } catch {
        result = LocalizationStore.getInstance().t('no data')
    }

    return result
}

export function createColumns() {
    const localizationStore = LocalizationStore.getInstance()
    let optionsTETypes = EnumHelpers.toKeyValueArray(TroubleEventType)
    let optionsTEStatuses = EnumHelpers.toKeyValueArray(TroubleEventStatus)

    return [
        {
            Header: localizationStore.t('troubleEventId'),
            maxWidth: 330,
            minWidth: 120,
            accessor: 'id',
            Cell: (cellInfo: CellInfo) => (
                <Link
                    className="qDetailLink"
                    to={'/troubleevent/' + cellInfo.row.id}
                    id={cellInfo.row.id}
                >
                    {cellInfo.row.id}
                </Link>
            ),
            sortable: false,
        },
        {
            Header: localizationStore.t('createDate'),
            accessor: 'createDate',
            maxWidth: 200,
            minWidth: 100,
            sortable: false,
            // filterMethod: (filter: any, row: any) =>
            //     -1 !== row[filter.id].toUpperCase().indexOf(filter.value.toUpperCase())
        },
        {
            Header: localizationStore.t('fullName'),
            maxWidth: 330,
            minWidth: 200,
            accessor: 'name',
            sortable: false,
        },
        {
            Header: localizationStore.t('creditNumber'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'creditNumber',
            filterable: true,
            sortable: false,
        },
        {
            Header: localizationStore.t('troubleEventType'),
            accessor: 'types',
            maxWidth: 300,
            minWidth: 140,
            Cell: (cellInfo: CellInfo) => (
                <span className="">
                    {getTroubleEventTypeText(cellInfo.row.types)}
                </span>
            ),
            filterable: true,
            sortable: false,

            filterMethod: (filter: any, row: any) => {
                if (optionsTETypes[filter.id]) {
                    return row[filter.id]
                } else {
                    return true
                }
            },
            Filter: (params: { filter: any, onChange: any }) => {
                return (
                    <div className="rt-th">
                        <select
                            onChange={event => params.onChange(event.target.value)}
                            style={{ height: '32px', width: '100%' }}
                        >
                            <option key={'all'} value={''}>
                                {localizationStore.t('Show all')}
                            </option>

                            {
                                optionsTETypes.map(x => {
                                    return (
                                        <option key={x.value} value={x.value}>
                                            {getTroubleEventTypeText(TroubleEventType[x.key])}
                                        </option>
                                    )
                                })
                            }
                        </select>
                    </div>
                )
            }
            // filterMethod: (filter: any, row: any) =>
            //     -1 !== getTroubleEventTypeText(row[filter.id])
            //         .toUpperCase()
            //         .indexOf(filter.value.toUpperCase())
        },
        {
            Header: localizationStore.t('troubleEventStatus'),
            accessor: 'statuses',
            maxWidth: 300,
            minWidth: 140,
            Cell: (cellInfo: CellInfo) => (
                <span className={getTroubleEventStatusClass(cellInfo.row.statuses)}>
                    {getTroubleEventStatusText(cellInfo.row.statuses)}
                </span>
            ),
            filterable: true,
            sortable: false,
            filterMethod: (filter: any, row: any) => {
                if (optionsTEStatuses[filter.id]) {
                    return row[filter.id]
                } else {
                    return true
                }
            },
            Filter: (params: { filter: any, onChange: any }) => {
                return (
                    <div className="rt-th">
                        <select
                            onChange={event => params.onChange(event.target.value)}
                            style={{ height: '32px', width: '100%' }}
                        >
                            <option key={'all'} value={''}>
                                {localizationStore.t('Show all')}
                            </option>

                            {
                                optionsTEStatuses.map(x => {
                                    return (
                                        <option key={x.value} value={x.value}>
                                            {getTroubleEventStatusText(TroubleEventStatus[x.key])}
                                        </option>
                                    )
                                })
                            }
                        </select>
                    </div>
                )
            }
            // filterMethod: (filter: any, row: any) =>
            //     -1 !== getTroubleEventStatusText(row[filter.id])
            //         .toUpperCase()
            //         .indexOf(filter.value.toUpperCase())
        },
        {
            Header: localizationStore.t('totalCustomerPayments'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'totalCustomerPayments',
            filterable: false,
            sortable: false,
        },
        {
            Header: localizationStore.t('CurrentDebt'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'currentDebt',
            filterable: false,
            sortable: false,
        },
        {
            Header: localizationStore.t('penalty'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'penalty',
            filterable: false,
            sortable: false,
        },
        {
            Header: localizationStore.t('currentDebtByCreditBody'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'currentDebtByCreditBody',
            filterable: false,
            sortable: false,
        },
        {
            Header: localizationStore.t('creditBodySum'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'creditBodySum',
            filterable: false,
            sortable: false,
        },

        {
            Header: localizationStore.t('paymentPerMonth'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'paymentPerMonth',
            filterable: false,
            sortable: false,
        },
        {
            Header: localizationStore.t('prepaymentSum'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'prepaymentSum',
            filterable: false,
            sortable: false,
        },

        {
            Header: localizationStore.t('phones'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'phones',
            filterable: false,
            sortable: false,
        },
        {
            Header: localizationStore.t('expireDate'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'expireDate',
            filterable: false,
            sortable: false,
        },
        {
            Header: localizationStore.t('products'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'products',
            filterable: false,
            sortable: false,
        },
        {
            Header: localizationStore.t('creditDuration'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'creditDuration',
            filterable: false,
            sortable: false,
        },

        {
            Header: localizationStore.t('openCreditDate'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'openCreditDate',
            filterable: false,
            sortable: false,
        },
        {
            Header: localizationStore.t('lastPaymentDate'),
            maxWidth: 330,
            minWidth: 100,
            accessor: 'lastPaymentDate',
            filterable: false,
            sortable: false,
        },
        {
            Header: localizationStore.t('lastComment'),
            maxWidth: 450,
            minWidth: 200,
            accessor: 'lastComment',
            filterable: false,
            sortable: false,
        },
        {
            Header: localizationStore.t('inProgressByUserId'),
            accessor: 'assignedUserId',
            Cell: (cellInfo: CellInfo) => (
                <Link
                    className="userDetailLink"
                    to={'/user/' + cellInfo.row.assignedUserId}
                    id={cellInfo.row.assignedUserId}
                >
                    {cellInfo.row.assignedUserId}
                </Link>
            ),
            maxWidth: 400,
            minWidth: 100,
            filterable: false,
            sortable: false,
        }
    ]
}

export function createStub(data: Array<ITroubleEvent>) {
    let troubleEvents = toJS(data)

    return troubleEvents.map(t => {
        try {
            return new TroubleEventsTableItem(t)
        } catch (ex) {
            console.error(ex)
            return undefined
        }
    }
    ).filter(x => x)
}

export function getPageCountNEW() {
    return EventsStore.getInstance().getPageCountNEW
}

export function getPageCountInProgress() {
    return EventsStore.getInstance().getPageCountInProgress
}

export function getPageCountAll() {
    return EventsStore.getInstance().getPageCountAll
}

export function onFetchTEDataNEW(state: any, instance: any) {
    HttpActionsService
        .getInstance()
        .getEvents(TroubleEventStatus.New, state.page, state.pageSize, state.filtered, state.sorted)
}

export function onFetchTEDataInProgress(state: any, instance: any) {
    const userStore = UserStore.getInstance()
    let filterClone = _.cloneDeep(state.filtered)

    if (!(userStore.checkAdmin || userStore.checkCollectionGroupAdministrator || userStore.checkSuperAdmin)) {
        filterClone.push({
            id: 'assignedUserId',
            value: userStore.id
        })
    }

    HttpActionsService
        .getInstance()
        .getEvents(TroubleEventStatus.InProgress, state.page, state.pageSize, filterClone, state.sorted)
}

export function onFetchQuestionnairesDataAll(state: any, instance: any) {
    HttpActionsService
        .getInstance()
        .getEvents(null, state.page, state.pageSize, state.filtered, state.sorted)
}

export function onFetchHistoryTEData(state: any, instance: any) {
    HttpActionsService
        .getInstance()
        .getEvents(null, state.page, state.pageSize, state.filtered, state.sorted, true)
}

export function getEventsTableNew() {
    const localizationStore = LocalizationStore.getInstance()
    const configStore = ConfigStore.getInstance()

    return (
        <ReactTable
            pages={getPageCountNEW()}
            data={createStub(EventsStore.getInstance().getNewList)}
            columns={createColumns()}
            defaultPageSize={configStore.getPageSize}
            className={c('-striped -highlight')}
            noDataText={localizationStore.t('No data text')}
            filterable={true}
            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
            previousText={localizationStore.t('Previous')}
            nextText={localizationStore.t('Next')}
            pageText={localizationStore.t('Page')}
            ofText={localizationStore.t('of')}
            manual
            onFetchData={_.debounce(onFetchTEDataNEW, 777)}
        />
    )
}

export function getEventsTableHistory() {
    const localizationStore = LocalizationStore.getInstance()
    const configStore = ConfigStore.getInstance()

    return (
        <ReactTable
            pages={getPageCountAll()}
            data={createStub(EventsStore.getInstance().getList)}
            columns={createColumns()}
            defaultPageSize={configStore.getPageSize}
            className={c('-striped -highlight')}
            noDataText={localizationStore.t('No data text')}
            filterable={true}
            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
            previousText={localizationStore.t('Previous')}
            nextText={localizationStore.t('Next')}
            pageText={localizationStore.t('Page')}
            ofText={localizationStore.t('of')}
            manual
            onFetchData={_.debounce(onFetchHistoryTEData, 777)}
        />
    )
}

export function getEventsTableInProgress() {
    const localizationStore = LocalizationStore.getInstance()
    const configStore = ConfigStore.getInstance()

    return (
        <ReactTable
            pages={getPageCountInProgress()}
            data={createStub(EventsStore.getInstance().getInProgressList)}
            columns={createColumns()}
            defaultPageSize={configStore.getPageSize}
            className={c('-striped -highlight')}
            noDataText={localizationStore.t('No data text')}
            filterable={true}
            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
            previousText={localizationStore.t('Previous')}
            nextText={localizationStore.t('Next')}
            pageText={localizationStore.t('Page')}
            ofText={localizationStore.t('of')}
            manual
            onFetchData={_.debounce(onFetchTEDataInProgress, 777)}
        />
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/TroubleEventsTableItem.tsx